import React, { ReactNode } from 'react';

export interface FieldContainerProps {
  children: ReactNode;
}

export default function FieldContainer({ children }: FieldContainerProps) {
  return <div>{children}</div>;
}
